var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyRemove = function SvgHappyRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.654 2.34a8 8 0 0 0-11.312.005A8 8 0 0 0 13.654 13.66a8.013 8.013 0 0 0 0-11.318zm-2.52 7.847a.667.667 0 0 1-.94.944L8.119 9.057a.167.167 0 0 0-.236 0L5.81 11.13a.68.68 0 0 1-.944 0 .67.67 0 0 1 0-.944L6.94 8.113a.163.163 0 0 0 0-.235L4.866 5.804a.668.668 0 0 1 .94-.944L7.88 6.934c.031.031.074.05.118.05s.087-.019.118-.05L10.19 4.86a.669.669 0 0 1 .944.944L9.059 7.878a.166.166 0 0 0 0 .235z"
  })));
};
export default SvgHappyRemove;